import { ReactNode, forwardRef } from 'react';

import { TableCell, TableCellProps } from '@material-ui/core';

import { MetadataText } from '@spotify/confidence-core-react';
import { WorkflowInstanceListItemFragment } from '@spotify/confidence-graphql';

import { usePlanningDates } from '../../hooks';
import { DraftReadinessText } from '../DraftReadinessText';
import { EndedRuntimeText } from '../EndedRuntimeText';
import { PlannedRuntimeProgress } from '../PlannedRuntimeProgress';

type PlanningProgressCellProps = TableCellProps & {
  workflowInstance: Pick<
    WorkflowInstanceListItemFragment,
    'state' | 'moduleData2' | 'checks'
  >;
  outcome?: ReactNode;
};

export const PlanningProgressCell = forwardRef<
  HTMLTableCellElement,
  PlanningProgressCellProps
>(({ workflowInstance, outcome = 'Finished', ...props }, ref) => {
  const { state, checks, moduleData2 } = workflowInstance;
  const {
    plannedStartDate,
    actualRuntime,
    progress,
    remainingDays,
    currentRuntime,
  } = usePlanningDates(moduleData2.planning);

  return (
    <TableCell {...props} ref={ref}>
      {state === 'draft' && (
        <DraftReadinessText
          checks={checks}
          plannedStartDate={plannedStartDate}
        />
      )}
      {(state === 'ended' || (state === 'archived' && actualRuntime)) && (
        <EndedRuntimeText label={outcome} actualRuntime={actualRuntime} />
      )}
      {state === 'archived' && !actualRuntime && (
        <MetadataText items={['Archived']} />
      )}
      {state === 'live' && (
        <PlannedRuntimeProgress
          progress={progress}
          remainingDays={remainingDays}
          currentRuntime={currentRuntime}
        />
      )}
    </TableCell>
  );
});
PlanningProgressCell.displayName = 'PlanningProgressCell';
